/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataQueryPartialExcludingIdRelatedToCreationInfoUpdateInfo } from '../models/data-query-partial-excluding-id-related-to-creation-info-update-info';
import { DataQueryWithTagDto } from '../models/data-query-with-tag-dto';
import { DataQueryWithTagDtoWithRelations } from '../models/data-query-with-tag-dto-with-relations';
import { MyQueryDtoWithRelations } from '../models/my-query-dto-with-relations';
import { NewDataQueries } from '../models/new-data-queries';
import { FilterExpressionCriteria } from '../models/filter-expression-criteria';
import { Count as LoopbackCount } from '../models/loopback/count';

@Injectable({ providedIn: 'root' })
export class DataQueryControllerService extends DataBaseService {

  /**
   * Path part for operation dataQueryControllerCount
   */
  static readonly DataQueryControllerCountPath = '/v1/entities/{entity}/queries/count';

  /**
   * Count all queries for specific entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params: {
    entity: string;
    where?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<LoopbackCount>> {

    const rb = new RequestBuilder(this.rootUrl, DataQueryControllerService.DataQueryControllerCountPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.query('where', params.where, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoopbackCount>;
      })
    );
  }
  /**
   * Count all queries for specific entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params: {
    entity: string;
    where?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<LoopbackCount> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<LoopbackCount>) => r.body as LoopbackCount)
    );
  }

  /**
   * Path part for operation dataQueryControllerFindById
   */
  static readonly DataQueryControllerFindByIdPath = '/v1/entities/{entity}/queries/{id}';

  /**
   * Get query by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    entity: string;
    id: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<DataQueryWithTagDtoWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, DataQueryControllerService.DataQueryControllerFindByIdPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataQueryWithTagDtoWithRelations>;
      })
    );
  }
  /**
   * Get query by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    entity: string;
    id: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<DataQueryWithTagDtoWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<DataQueryWithTagDtoWithRelations>) => r.body as DataQueryWithTagDtoWithRelations)
    );
  }

  /**
   * Path part for operation dataQueryControllerDeleteById
   */
  static readonly DataQueryControllerDeleteByIdPath = '/v1/entities/{entity}/queries/{id}';

  /**
   * Delete query by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DataQueryControllerService.DataQueryControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * Delete query by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<any> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation dataQueryControllerUpdateById
   */
  static readonly DataQueryControllerUpdateByIdPath = '/v1/entities/{entity}/queries/{id}';

  /**
   * Update query by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: DataQueryPartialExcludingIdRelatedToCreationInfoUpdateInfo
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, DataQueryControllerService.DataQueryControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }
  /**
   * Update query by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    entity: string;
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: DataQueryPartialExcludingIdRelatedToCreationInfoUpdateInfo
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation dataQueryControllerFind
   */
  static readonly DataQueryControllerFindPath = '/v1/entities/{entity}/queries';

  /**
   * List all queries for specific entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params: {
    entity: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataQueryWithTagDtoWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, DataQueryControllerService.DataQueryControllerFindPath, 'get');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataQueryWithTagDtoWithRelations>>;
      })
    );
  }
  /**
   * List all queries for specific entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params: {
    entity: string;
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataQueryWithTagDtoWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataQueryWithTagDtoWithRelations>>) => r.body as Array<DataQueryWithTagDtoWithRelations>)
    );
  }

  /**
   * Path part for operation dataQueryControllerCreate
   */
  static readonly DataQueryControllerCreatePath = '/v1/entities/{entity}/queries';

  /**
   * Create new query for specific entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params: {
    entity: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewDataQueries
  }): Observable<StrictHttpResponse<DataQueryWithTagDto>> {

    const rb = new RequestBuilder(this.rootUrl, DataQueryControllerService.DataQueryControllerCreatePath, 'post');
    if (params) {
      rb.path('entity', params.entity, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DataQueryWithTagDto>;
      })
    );
  }
  /**
   * Create new query for specific entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params: {
    entity: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: NewDataQueries
  }): Observable<DataQueryWithTagDto> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<DataQueryWithTagDto>) => r.body as DataQueryWithTagDto)
    );
  }

  /**
   * Path part for operation dataQueryControllerFindMyQueries
   */
  static readonly DataQueryControllerFindMyQueriesPath = '/v1/queries/my';

  /**
   * List all queries for current user in a view or in all views
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findMyQueries()` instead.
   *
   * This method doesn't expect any request body.
   */
  findMyQueries$Response(params?: {
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<MyQueryDtoWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, DataQueryControllerService.DataQueryControllerFindMyQueriesPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MyQueryDtoWithRelations>>;
      })
    );
  }
  /**
   * List all queries for current user in a view or in all views
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findMyQueries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findMyQueries(params?: {
    filter?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<MyQueryDtoWithRelations>> {

    return this.findMyQueries$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MyQueryDtoWithRelations>>) => r.body as Array<MyQueryDtoWithRelations>)
    );
  }

  /**
   * Path part for operation dataQueryControllerCriteriaParser
   */
  static readonly DataQueryControllerCriteriaParserPath = '/v1/queries/parser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `criteriaParser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  criteriaParser$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: null | FilterExpressionCriteria
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, DataQueryControllerService.DataQueryControllerCriteriaParserPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `criteriaParser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  criteriaParser(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
    body?: null | FilterExpressionCriteria
  }): Observable<string> {

    return this.criteriaParser$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

}
